export interface User {
  id: string;
  organizations: string[];
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  featureFlags?: FeatureFlags;
  pubnubKeys?: PubnubKeys;
  permissions: string[];
}

export const canManagePatients = (user: User | null) => {
  return (
    user &&
    (!user.featureFlags?.enableRestrictManagePatients ||
      (user.featureFlags?.enableRestrictManagePatients &&
        user.permissions.indexOf("reach.can_manage_patients") > -1))
  );
};

export interface ParticipantUser {
  systemUserId: string;
  fullName: string;
  firstName: string;
  lastName: string;
  isPatient: boolean;
  pubnubKeys: PubnubKeys;
}

// Make sure new feature flags are not required
export interface FeatureFlags {
  enableBulkSms?: boolean;
  enableVideo?: boolean;
  enableVirtualWaitingRoom?: boolean;
  enableVwrCreateDemo?: boolean;
  enablePatientUpload?: boolean;
  enableRestrictManagePatients?: boolean;
}

export interface PubnubKeys {
  publishKey: string;
  subscribeKey: string;
}
